/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
import * as React from "react";
import { BillingScreenStyle, TransferCancelSubscriptionHeaderWrapper } from "./billing-screen-style";
import { RouteComponentProps } from "react-router-dom";
import NavBreadcrumb from "../breadcrumb/nav-breadcrumb";
import { OrganizationsState, RootState, TileDescriptionsState, TileDescription } from "store/types";
import { connect } from "react-redux";
import {
    makeNavBreadcrumbItems,
    BillingInfo,
    getBillingInfo,
    deleteOrg,
    isUserOrgID,
    toTileDescription,
    openApp,
} from "../orgs-lib";
import SectionHeader from "../section-header/section-header";
import { Card, CardSecondary, Grid, LoadingIndicator, RoundedRect } from "../orgs-styles";
import MoreMenu from "../more-menu/more-menu";
import ActionModal from "designer/modals/smart/action-modal/action-modal";
import { overview, upgrade, appSettings } from "routes";
import { TransitionGroup, CSSTransition } from "react-transition-group";
import {
    UserDataAndState,
    isUserData,
    isShortName,
    getAppEminence,
    AppPlanCodeEntry,
    MonthlySubscription,
    AnnualSubscription,
    getUserFeatures,
    Owner,
    Organization,
} from "common/Database";
import Button from "designer/ui/smart/button/button";
import InputLabel from "designer/ui/smart/input-label/input-label";

import { initChargebee } from "designer/lib/chargebee-api";
import { getAppFacilities } from "webapp/lib/app-renderer";
import {
    DeleteTaxBody,
    GetTaxBody,
    MakeSupportCodeForAppBody,
    SetAdditionalBillingBody,
    SetTaxBody,
    StripeSubscriptionRepresentation,
} from "common/firebase-function-types";
import { redirectToStripeCheckout } from "webapp/lib/stripe-api";
import { removeQueryStrings } from "lib/browser-hacks";
import * as actions from "actions/actions";
import { Icon } from "common/render/icon";
import { Trash } from "common/react-plucked";
import { logError, logInfo } from "common/debug-print";
import { Eminence } from "common/Database/eminence";
import { assert, checkString, dontAwait, isResponseOK } from "common/Support";
import { MappedThunk } from "actions/action-thunk";
import { trackEvent } from "analytics";
import BillingBoosts from "./private/boosts";
import { getFeatureSetting } from "common/feature-settings";
import SubscriptionTile from "./private/subscription-tile";
import { getPlanName } from "common/app-plans";
import * as appsActions from "actions/apps-actions";
import UserHeader from "./private/user-header";
import { OwnerKind } from "common/Database/owner-kind";
import { legacyUpgrade } from "./private/legacy-upgrade";
import { withTheme } from "styled-components";
import { BuilderTheme } from "sharedUI/styles";
import { TAX_TYPES } from "designer/apps/lib/stripe-tax-types";
import { GlideDropdown } from "designer/ui/smart/glide-dropdown/glide-dropdown";
import { withModalProvider } from "designer/modals-v2/modal-provider-v2/modal-provider-v2";
import {
    DefaultErrorMessage,
    SupportLinkCreateError,
    CreateSupportLink,
    SaveTaxDetailsError,
} from "designer/modals-v2/modal-snippet-library";
import WindowedModalV2 from "designer/modals-v2/windowed-modal/windowed-modal";
import { ButtonVNext } from "designer/ui/smart/button-vnext/button-vnext";
import TransferModal from "designer/modals/smart/transfer-modal/transfer-modal";
import { SimpleModalContextProps } from "designer/modals-v2/modal-provider-v2/modal-context";
import { ItemDescription } from "designer/lib/dropdown-types";
import { SubscriptionSKU } from "designer/modals/smart/upgrade-modal/upgrade-modal";

interface RouteProps {
    readonly orgID: string | undefined;
}

interface TaxObject {
    id: string;
    type: string;
    value: string;
    country: string;
}
interface Props extends RouteComponentProps<RouteProps> {
    readonly organizations: OrganizationsState;
    readonly userData: UserDataAndState;
    readonly tiles: TileDescriptionsState;
    readonly loadTileDescriptionFromFirebase: MappedThunk<typeof actions.loadTileDescriptionFromFirebase>;
    readonly unloadApps: typeof appsActions.unloadApps;
    readonly theme: BuilderTheme;
    readonly modals: SimpleModalContextProps;
}

interface State {
    readonly billing: BillingInfo | undefined | "loading";
    readonly subscriptions: readonly StripeSubscriptionRepresentation[] | undefined | "loading";
    taxItems: TaxObject[] | [];
    taxValue: string;
    companyName: string;
    additionalInfo: string;
    taxType: string;
    showTaxOptions: boolean;
}

async function loadStripeSubscriptions(
    finishSession: string | undefined,
    cancelApps: string[],
    uncancelApps: string[],
    transferSubscription: { from: string; to: string } | undefined
): Promise<readonly StripeSubscriptionRepresentation[] | undefined> {
    const response = await getAppFacilities().callAuthCloudFunction("listStripeSubscriptions", {
        finishSessions: finishSession === undefined ? [] : [finishSession],
        cancelApps,
        uncancelApps,
        transferSubscription,
    });
    if (response === undefined || !response.ok) return undefined;
    return (await response.json()) as readonly StripeSubscriptionRepresentation[];
}

class BillingScreenImpl extends React.PureComponent<Props, State> {
    private checkoutSessionID: string | undefined;
    private cancelApps: string[] = [];
    private uncancelApps: string[] = [];
    private transferSubscription: { from: string; to: string } | undefined;

    public state: State = {
        billing: "loading",
        subscriptions: "loading",
        taxValue: "",
        companyName: "",
        additionalInfo: "",
        taxType: "",
        taxItems: [],
        showTaxOptions: false,
    };

    private get orgID(): string | undefined {
        return this.props.match.params.orgID;
    }

    private async tryLoadSubscriptions(force: boolean = false) {
        const { userData } = this.props;
        const { transferSubscription } = this;
        this.transferSubscription = undefined;
        // If we synchronously set the state to "loading" and _then_
        // enter tryLoadSubscriptions, then React, in its infinite wisdom,
        // doesn't actually set the state. Apparently that only happens in
        // the next microtask. So sometimes we just have to force it.
        if (isUserData(userData) && (force || this.state.subscriptions === "loading")) {
            const subscriptions = await loadStripeSubscriptions(
                this.checkoutSessionID,
                this.cancelApps.splice(0, this.cancelApps.length),
                this.uncancelApps.splice(0, this.uncancelApps.length),
                transferSubscription
            );
            this.checkoutSessionID = undefined;
            this.setState({ subscriptions, billing: undefined });
        }
    }

    private async cancelAppSubscription(appID: string) {
        this.cancelApps.push(appID);
        trackEvent("downgrade", { app_id: appID });
        this.setState({ subscriptions: "loading" });
        await this.tryLoadSubscriptions();
    }

    private async uncancelAppSubscription(appID: string) {
        this.uncancelApps.push(appID);
        this.setState({ subscriptions: "loading" });
        await this.tryLoadSubscriptions(true);
    }

    private async transferAppSubscription(fromAppID: string, toAppID: string) {
        assert(
            this.transferSubscription === undefined,
            "Transfer subscriptions must be undefined when requesting a transfer"
        );
        this.transferSubscription = { from: fromAppID, to: toAppID };
        this.setState({ subscriptions: "loading" });
        await this.tryLoadSubscriptions();
    }

    private getAdditionalInfo(owner: Owner | undefined) {
        if (owner && owner.customerInformation) {
            this.setState({
                additionalInfo: owner.customerInformation.additionalInfo ?? "",
                companyName: owner.customerInformation.customerName ?? "",
            });
        } else {
            logError("No owner found");
        }
    }

    private async getUserTaxInfo(owner: Owner | undefined) {
        if (owner && owner.id) {
            const body: GetTaxBody = {
                ownerID: owner.id,
            };
            const response = await getAppFacilities().callAuthCloudFunction("getTaxInfo", body);
            if (response === undefined || !response.ok) {
                logError("No tax results found");
            } else {
                const taxResponse = await response.json();
                this.setState({ taxItems: taxResponse });
            }
        } else {
            logError("No owner found");
        }
    }

    private async deleteTaxInfo(owner: Owner | undefined, taxID: string) {
        if (owner && owner.id) {
            const body: DeleteTaxBody = {
                ownerID: owner.id,
                taxID: taxID,
            };
            const confirmation = await this.props.modals.showAcceptCancelModal(
                "Delete Tax Selection",
                "Are you sure you want to delete this VAT tax selection?",
                "Delete",
                "danger"
            );

            if (confirmation) {
                const response = await getAppFacilities().callAuthCloudFunction("deleteTaxInfo", body);
                if (response === undefined || !response.ok) {
                    logError("Unable to delete tax selection");
                } else {
                    await this.getUserTaxInfo(owner);

                    await this.props.modals.showSimpleInfoModal("Success", "Deleted VAT tax selection successfully!");
                }
            }
        } else {
            logError("No owner found");
        }
    }

    public async componentDidMount() {
        const params = new URLSearchParams(window.location.search);
        const checkoutSessionID = params.get("checkoutSessionID");
        if (checkoutSessionID !== null) {
            removeQueryStrings("checkoutSessionID");
            this.checkoutSessionID = checkoutSessionID;
        }
        if (isUserOrgID(this.orgID)) {
            await this.tryLoadSubscriptions();
        } else {
            const billingInfo = await getBillingInfo(this.orgID);
            this.setState({ subscriptions: undefined, billing: billingInfo });
        }
        const org = this.props.organizations.find(o => o.id === this.props.match.params.orgID);
        if (org !== undefined) {
            await this.getAdditionalInfo(org);
            await this.getUserTaxInfo(org);
        }
    }

    public async componentDidUpdate(prevProps: Props) {
        const { userData } = this.props;
        if (prevProps.userData === userData) return;

        if (isUserData(prevProps.userData) && isUserData(userData) && prevProps.userData.id === userData.id) return;
        if (!isUserOrgID(this.orgID)) return;

        this.setState({ subscriptions: "loading" });
        await this.tryLoadSubscriptions();
    }

    private deleteOrg = () => {
        const org = this.props.organizations.find(o => o.id === this.props.match.params.orgID);
        if (org === undefined) return;

        dontAwait(
            this.props.modals.showModal<void>(resolve => {
                return (
                    <WindowedModalV2 canClose={true} hideClosingButton={true} onClose={resolve}>
                        <ActionModal
                            header={`Delete ${org.displayName}?`}
                            description="Your team and all associated apps will be permanently deleted. This action cannot be undone."
                            destroyText="Delete"
                            cancelText="Cancel"
                            destroyAction={async () => {
                                await deleteOrg(org.id);
                                this.props.history.replace(overview);
                            }}
                        />
                    </WindowedModalV2>
                );
            })
        );
    };

    private manageAccount = async () => {
        const f = getAppFacilities();
        const orgID = this.props.match.params.orgID;

        const cb = await initChargebee();
        const cbPortal = cb.createChargebeePortal();
        cb.setPortalSession(async () => {
            const result = await f.callAuthCloudFunction("chargebeePortalSession", {
                organizationID: orgID,
            });
            const json = await result?.json();
            return json;
        });
        cbPortal.open({
            close() {
                // do nothing
            },
        });
    };

    private upgradeOrg = () => {
        const orgID = this.props.match.params.orgID;
        if (orgID === undefined) return;

        this.props.history.push(upgrade(orgID));
    };

    private renderBillingTransitionGroup(owner: Owner | undefined, children: React.ReactNode, newStyle: boolean) {
        const ownerIsUser = owner?.kind === OwnerKind.User;
        const boostsForOwner = new Set((owner?.monthlySubscription?.boostCodes ?? []).map(boost => boost.code));
        const hasBoosts = boostsForOwner.size > 0;

        // If a user has no boosts, we should not show the option to set them since we are phasing them out.
        // This applies to the following cases
        //   - The user is a new user
        //   - The user had boosts but has cancelled them all
        const shouldShowBoosts = getFeatureSetting("boosts") && ownerIsUser && hasBoosts;

        return (
            <TransitionGroup>
                <CSSTransition key="bill-trans" classNames="bill-trans" appear={true} timeout={250}>
                    <Grid>
                        <main>
                            {React.Children.count(children) > 0 && (
                                <Card className="bill-apps">
                                    <div className="card-header">
                                        <div className="card-title">Basic &amp; Pro apps</div>
                                    </div>
                                    <div className="card-grid">
                                        {children}
                                        <div
                                            className={
                                                newStyle ? "bill-center-wrapped" : "bill-center-container"
                                            }></div>
                                    </div>
                                </Card>
                            )}
                            {this.renderAdditionalBillingInfo(owner)}
                        </main>
                        <aside>
                            {owner !== undefined && getUserFeatures(owner).unifiedPricing && (
                                <CardSecondary>
                                    <div className="card-header">
                                        <div className="card-title">Summary</div>
                                    </div>
                                    <div className="card-content">
                                        <UserHeader owner={owner} />
                                    </div>
                                </CardSecondary>
                            )}
                            {shouldShowBoosts ? <BillingBoosts orgID={this.orgID} /> : null}
                            <CardSecondary>
                                <div className="card-content">
                                    <div className="card-title">Questions?</div>
                                    <p>Our support team will be happy to help.</p>
                                    <ButtonVNext
                                        isFullWidth={true}
                                        onClick={() => window.open("mailto:support@glideapps.com", "_blank")}
                                        buttonType={"secondary"}
                                        variant={"default"}
                                        size={"md"}
                                        label={"Contact Support"}
                                    />
                                </div>
                            </CardSecondary>
                        </aside>
                    </Grid>
                </CSSTransition>
            </TransitionGroup>
        );
    }

    private renderAdditionalBillingInfo(owner: Owner | undefined) {
        const { userData, theme } = this.props;
        // Only allow admins to add, delete.
        let isAdmin = owner?.kind === OwnerKind.User;

        if (owner?.kind === OwnerKind.Organization && isUserData(userData)) {
            if (owner.memberUserIDs[0] === userData.id) {
                // FIXME: This isn't a good way to do this!
                isAdmin = true;
            }
        }

        return (
            <Card className="bill-apps">
                <div className="card-header">
                    <div className="card-title">Billing Information</div>
                </div>

                <div className="card-content">
                    <div className="tax-header-wrapper">Company Name</div>
                    <div className="cos2-name-info-wrap">
                        <InputLabel
                            autoFocus={false}
                            margin={0}
                            label={undefined}
                            placeholder={owner?.customerInformation?.customerName ?? "Company name (optional)"}
                            value={this.state.companyName}
                            onChange={e => this.setState({ companyName: e.target.value })}
                        />
                    </div>
                    <div className="tax-header-wrapper">Additional Information</div>
                    <div className="cos2-name-info-wrap">
                        <InputLabel
                            autoFocus={false}
                            margin={0}
                            label={undefined}
                            placeholder={
                                owner?.customerInformation?.additionalInfo ?? "Team, location, etc. (optional)"
                            }
                            value={this.state.additionalInfo}
                            onChange={e => this.setState({ additionalInfo: e.target.value })}
                        />
                    </div>

                    {isAdmin && (
                        <div className="save-button-wrapper">
                            <ButtonVNext
                                onClick={async () => {
                                    if (owner !== undefined && owner.id !== undefined) {
                                        await this.setBillingInfo(owner);
                                    } else {
                                        await this.props.modals.showSimpleInfoModal(
                                            "Error - Could not set additional Billing info.",
                                            DefaultErrorMessage
                                        );
                                    }
                                }}
                                buttonType={"primary"}
                                variant={"default"}
                                size={"md"}
                                disabled={
                                    owner?.customerInformation?.additionalInfo === this.state.additionalInfo &&
                                    owner?.customerInformation?.customerName === this.state.companyName
                                }
                                label="Save Billing Information"
                            />
                        </div>
                    )}
                </div>
                <div className="card-header">
                    <div className="card-title">Tax Details</div>
                </div>
                <div className="card-content">
                    <div className="tax-header-wrapper">
                        <div className="cos2-option-name">Tax Type</div>
                        <div className="cos2-option-name">Tax ID</div>
                    </div>

                    {this.state.taxItems.length > 0 && this.getTaxItems(owner, theme, isAdmin)}
                    {this.state.taxItems.length === 0 || this.state.showTaxOptions ? (
                        <div className="tax-details-container">
                            <div className="cos2-drop-wrap">
                                <GlideDropdown<string>
                                    items={TAX_TYPES}
                                    descriptionForItem={i => i}
                                    isEnabled={true}
                                    selected={this.state.taxType !== "" ? this.state.taxType : undefined}
                                    onItemSelect={e => this.setState({ taxType: e })}
                                    defaultDisplayLabel="-"
                                />
                            </div>
                            <div className="cos2-input-wrap">
                                <InputLabel
                                    autoFocus={false}
                                    margin={0}
                                    label={undefined}
                                    placeholder={"e.g. DE1234565689"}
                                    value={this.state.taxValue}
                                    onChange={e => this.setState({ taxValue: e.target.value })}
                                />
                            </div>
                            {isAdmin && this.state.taxItems.length > 0 && (
                                <div
                                    className="delete-tax-wrapper"
                                    onClick={() => this.setState({ showTaxOptions: false })}>
                                    <Trash color={theme.fgColorMedium} size={16} />
                                </div>
                            )}
                        </div>
                    ) : (
                        <div className="tax-button-wrapper">
                            <ButtonVNext
                                isFullWidth={true}
                                onClick={() => this.setState({ showTaxOptions: true })}
                                buttonType={"minimal"}
                                variant={"accent"}
                                size={"md"}
                                label={"Add another Tax ID"}
                            />
                        </div>
                    )}

                    {isAdmin && (
                        <div className="save-button-wrapper">
                            <ButtonVNext
                                onClick={async () => {
                                    if (owner !== undefined && owner.id !== undefined) {
                                        await this.setTaxInfo(owner);
                                        // reset values to refresh buttons and tax values
                                        this.setState({ taxValue: "", taxType: "" });
                                        await this.getUserTaxInfo(owner);
                                    } else {
                                        await this.props.modals.showSimpleInfoModal(
                                            "Error - Can't modify tax details because owner, tax value, or tax type is not defined",
                                            DefaultErrorMessage
                                        );
                                    }
                                }}
                                buttonType={"primary"}
                                variant={"default"}
                                size={"md"}
                                disabled={this.state.taxValue === "" && this.state.taxType === ""}
                                label="Save Tax Details"
                            />
                        </div>
                    )}
                </div>
            </Card>
        );
    }

    private getTaxItems(owner: Owner | undefined, theme: BuilderTheme, isAdmin: boolean): React.ReactNode[] {
        const items: React.ReactNode[] = [];
        for (let item = 0; item < this.state.taxItems.length; item++) {
            items.push(
                <div className="tax-details-container" key={this.state.taxItems[item].id}>
                    <div className="cos2-drop-wrap">
                        <GlideDropdown<string>
                            items={TAX_TYPES}
                            descriptionForItem={i => i}
                            selected={this.state.taxItems[item].type ?? ""}
                            onItemSelect={() => undefined}
                        />
                    </div>

                    <div className="cos2-input-wrap">
                        <InputLabel
                            autoFocus={false}
                            margin={0}
                            label={undefined}
                            placeholder={this.state.taxItems[item].value ?? ""}
                            value={this.state.taxItems[item].value}
                            onChange={() => undefined}
                        />
                    </div>
                    {isAdmin && (
                        <div
                            className="delete-tax-wrapper"
                            onClick={() => this.deleteTaxInfo(owner, this.state.taxItems[item].id)}>
                            <Trash color={theme.fgColorMedium} size={16} />
                        </div>
                    )}
                </div>
            );
        }
        return items;
    }

    private renderError(): React.ReactNode {
        return <SectionHeader name="Error loading billing" />;
    }

    private renderOrg(org: Organization | undefined): React.ReactNode {
        const { organizations, match, userData, loadTileDescriptionFromFirebase, tiles } = this.props;
        const billing = this.state.billing;
        const orgID = match.params.orgID;

        let isAdmin = false;
        if (org !== undefined && isUserData(userData)) {
            if (org.memberUserIDs[0] === userData.id) {
                // FIXME: This isn't a good way to do this!
                isAdmin = true;
            }
        }

        let content: React.ReactNode;
        if (!isUserData(userData)) {
            content = null;
        } else if (billing === "loading") {
            content = <LoadingIndicator />;
        } else if (billing === undefined) {
            content = this.renderError();
        } else {
            const isFreePlan = billing.canUpgrade;

            let actionButton: React.ReactNode;
            if (billing.canUpgrade) {
                actionButton = isAdmin ? (
                    <Button variant="inline" className="bill-cta" onClick={this.upgradeOrg}>
                        Upgrade plan
                    </Button>
                ) : (
                    <Button variant="inline" className="bill-cta" disabled={true}>
                        Contact this org's Owner to upgrade
                    </Button>
                );
            } else if (!billing.canUpgrade) {
                actionButton = isAdmin ? (
                    <Button variant="inline" className="bill-cta" onClick={this.manageAccount}>
                        Manage account
                    </Button>
                ) : (
                    <Button variant="inline" className="bill-cta" disabled={true}>
                        Contact this org's Owner to make changes
                    </Button>
                );
            }

            content = this.renderBillingTransitionGroup(
                undefined,
                <RoundedRect className="bill-rect">
                    <div className="bill-header">
                        <div>Plan Details</div>
                        {actionButton}
                    </div>
                    <div className="bill-line-header">Internal App users</div>
                    <div className="bill-line">
                        <Icon size={24} image={{ emoji: "👥" }} color="#E8E8E8" clipCorners={true} omitShadow={true} />
                        <div className="bill-line-title">
                            <span className="bold">{billing.additionalUsers} users</span>{" "}
                            <span className="grey">(${billing.pricePerUser / 100} each)</span>
                        </div>
                        <div className="bill-line-total padded">
                            ${(billing.additionalUsers * billing.pricePerUser) / 100}
                        </div>
                    </div>
                    {billing.publicAppIDs.length > 0 && <div className="bill-line-header">Public Apps</div>}
                    {billing.publicAppIDs.map(id => {
                        const appTile = toTileDescription(id, userData.id, tiles, loadTileDescriptionFromFirebase);
                        if (appTile === undefined) return null;
                        return (
                            <div className="bill-line">
                                <Icon
                                    size={24}
                                    image={appTile.iconImage}
                                    color={appTile.primaryAccentColor}
                                    clipCorners={true}
                                />
                                <div className="bill-line-title">
                                    <span className="bold">{appTile.title}</span>
                                </div>
                                <div className="bill-line-total">
                                    <div>${billing.pricePerApp / 100}</div>
                                    <MoreMenu
                                        size={28}
                                        items={["Unpublish"]}
                                        descriptionForItem={i => ({
                                            name: i,
                                            visualStyle: "destructive",
                                        })}
                                        onItemClick={async () => {
                                            const f = getAppFacilities();
                                            await f.callAuthCloudFunction("unpublishApp", {
                                                appID: id,
                                            });
                                            const newBilling = await getBillingInfo(orgID);
                                            if (newBilling !== undefined) {
                                                this.setState({ billing: newBilling });
                                            }
                                        }}
                                    />
                                </div>
                            </div>
                        );
                    })}
                    {!isFreePlan && (
                        <div className="bill-line bill-total">
                            <div className="bill-total-next-payment">Next payment on {billing.nextBillDate}</div>
                            <div className="bill-total-estimated-total">
                                Estimated Total*{" "}
                                <span className="bill-total-estimated-total-price">${billing.totalPrice / 100}</span>
                            </div>
                        </div>
                    )}
                    <div className="bill-footer">
                        * Final amount can change with use. Questions?{" "}
                        <a href="mailto:support@glideapps.com">Contact us</a>.
                    </div>
                </RoundedRect>,
                false
            );
        }

        return (
            <BillingScreenStyle>
                <div className="bill-nav">
                    <NavBreadcrumb items={makeNavBreadcrumbItems("Billing", orgID, organizations)} />
                    {isAdmin && (
                        <div className="bill-more">
                            <MoreMenu
                                items={["Delete team"]}
                                descriptionForItem={i => ({
                                    name: i,
                                    visualStyle: "destructive",
                                })}
                                onItemClick={this.deleteOrg}
                            />
                        </div>
                    )}
                </div>
                {content}
            </BillingScreenStyle>
        );
    }

    private onSubscriptionUpdateClick = async (sessionID: string) => {
        await redirectToStripeCheckout(sessionID);
    };

    private appIconForAppTile(appTile: TileDescription) {
        return appTile.iconImage === undefined ? null : (
            <Icon size={24} image={appTile.iconImage} color={appTile.primaryAccentColor} clipCorners={true} />
        );
    }

    private async showCancelAppModal(appTile: TileDescription & { appID: string }, nextInvoiceDate?: Date) {
        const cancelHeader = `Cancel subscription for ${appTile.title}`;

        const downgradesOn =
            nextInvoiceDate === undefined
                ? "at the end of the billing cycle"
                : `on ${nextInvoiceDate.toLocaleDateString()}`;

        let shortNameHost: string | undefined;
        try {
            const { host } = new URL(appTile.url);
            shortNameHost = isShortName(host) ? host : undefined;
        } catch {
            logInfo(`App tile URL ${appTile.url} is not a URL.`);
        }
        const downgradeConsequence =
            shortNameHost === undefined
                ? "and free app limits will apply."
                : `it will no longer be accessible at ${shortNameHost}, and free app limits will apply.`;
        const cancelContent = (
            <p>
                Your app will downgrade to free {downgradesOn}, {downgradeConsequence}
            </p>
        );
        const shouldCancel = await this.props.modals.showAcceptCancelModal(
            cancelHeader,
            cancelContent,
            "Cancel subscription",
            "danger"
        );

        if (shouldCancel) {
            await this.cancelAppSubscription(appTile.appID);
            const goToForm = await this.props.modals.showAcceptCancelModal(
                "Tell us how we did?",
                "Your feedback helps us grow and improve Glide.",
                "Okay"
            );
            if (goToForm) {
                window.location.href = "https://glide.typeform.com/to/mfYuv8";
            }
        }
    }

    private async showTransferAppModal(appTile: TileDescription & { appID: string }) {
        const { userData, loadTileDescriptionFromFirebase, modals } = this.props;
        if (!isUserData(userData)) return;

        const transferHeader = (
            <TransferCancelSubscriptionHeaderWrapper>
                {this.appIconForAppTile(appTile)}
                <div className={"header-text"}>Transfer subscription from {appTile.title}</div>
            </TransferCancelSubscriptionHeaderWrapper>
        );

        const freeAppIDs = userData.appIDs.filter(a => getAppEminence(userData, a, undefined) === Eminence.Free);

        const { subscriptions } = this.state;
        // We hide the subscriptions from the render() method here to simulate a loading
        // indicator. It's not great, but it's what we've got.
        this.setState({ subscriptions: "loading" });
        try {
            const tileLoads: Promise<void>[] = [];
            for (const freeAppID of freeAppIDs) {
                // However, we can put the subscriptions back so long as at least one free app was
                // loaded. That way, we don't have to re-render the subscription screen.
                const prior = this.props.tiles[freeAppID];
                if (prior !== undefined && prior !== "loading" && this.state.subscriptions === "loading") {
                    this.setState({ subscriptions });
                }
                tileLoads.push(loadTileDescriptionFromFirebase(userData.id) as any);
            }
            await Promise.all(tileLoads);
        } finally {
            this.setState({ subscriptions });
        }

        // We extract "tiles" down here because we have punched out of the React lifecycle.
        // If we extract it before we load all the free tile descriptions, we don't get any
        // free tile descriptions in the tiles variable.
        const { tiles } = this.props;
        const dropdownEntries = freeAppIDs.map(appID => {
            const tileEntry = tiles[appID];
            if (tileEntry === "loading" || tileEntry === undefined) {
                return { code: appID, label: appID, color: "#000000", icon: undefined };
            }
            return {
                code: appID,
                label: tileEntry.title,
                color: tileEntry.primaryAccentColor,
                icon: tileEntry.iconImage,
            };
        });

        const transferDestAppID = await modals.showModal<string | undefined>(resolve => {
            return (
                <WindowedModalV2 canClose={false} onClose={() => resolve(undefined)} hideClosingButton={true}>
                    <TransferModal
                        choices={dropdownEntries}
                        header={transferHeader}
                        dropdownLabel="Transfer Pro subscription to"
                        onAccept={resolve}
                        onCancel={() => resolve(undefined)}
                    />
                </WindowedModalV2>
            );
        });

        if (transferDestAppID !== undefined) {
            await this.transferAppSubscription(appTile.appID, transferDestAppID);
        }
    }

    private makeSupportCode = async (appID: string): Promise<void> => {
        const body: MakeSupportCodeForAppBody = { appID };
        const response = await getAppFacilities().callAuthCloudFunction("makeSupportCodeForApp", body);
        if (!isResponseOK(response)) {
            await this.props.modals.showSimpleInfoModal(
                SupportLinkCreateError.title,
                SupportLinkCreateError.bodyContent
            );
            return;
        }
        const { url } = await response.json();
        await this.props.modals.showSimpleInfoModal(
            CreateSupportLink(checkString(url)).title,
            CreateSupportLink(checkString(url)).bodyContent
        );
    };

    private setBillingInfo = async (owner: Owner): Promise<void> => {
        if (owner && owner.id) {
            const body: SetAdditionalBillingBody = {
                ownerID: owner.id,
                additionalInfo:
                    this.state.additionalInfo !== ""
                        ? this.state.additionalInfo
                        : owner?.customerInformation?.additionalInfo,
                companyName:
                    this.state.companyName !== "" ? this.state.companyName : owner?.customerInformation?.customerName,
            };
            const response = await getAppFacilities().callAuthCloudFunction("setAdditionalBillingInfo", body);
            if (!isResponseOK(response)) {
                await this.props.modals.showSimpleInfoModal(
                    "Error - Could not set additional Billing info",
                    DefaultErrorMessage
                );
            } else {
                await this.props.modals.showSimpleInfoModal("Success", "Saved billing info successfully!");
            }
        } else {
            logError("No owner found, unable to set additional billing information");
        }
    };

    private setTaxInfo = async (owner: Owner): Promise<void> => {
        // Please keep in mind that that value must match the format for the type.
        // ex: with a tax type of eu_vat my value must match that type. (123 won't work)
        // DE123456789 is a value that would work
        //https://stripe.com/docs/api/customer_tax_ids/create
        if (owner && owner.id) {
            const body: SetTaxBody = {
                ownerID: owner.id,
                type: this.state.taxType,
                value: this.state.taxValue,
            };
            const response = await getAppFacilities().callAuthCloudFunction("setTaxInfo", body);
            if (!isResponseOK(response)) {
                await this.props.modals.showSimpleInfoModal(SaveTaxDetailsError.title, SaveTaxDetailsError.bodyContent);
            } else {
                await this.props.modals.showSimpleInfoModal("Success", "Saved tax details successfully!");
            }
        } else {
            await this.props.modals.showSimpleInfoModal(SaveTaxDetailsError.title, SaveTaxDetailsError.bodyContent);
        }
    };

    private renderSubscription = (userID: string, subscription: StripeSubscriptionRepresentation): React.ReactNode => {
        const { loadTileDescriptionFromFirebase, tiles } = this.props;
        const { appID, planSKU, nextInvoice, cancelsAt, subscriptionID, checkoutSessionID } = subscription;
        // JavaScript months are always 0 indexed. Which is weird.
        const nextInvoiceDate =
            nextInvoice !== undefined ? new Date(nextInvoice.year, nextInvoice.month - 1, nextInvoice.day) : undefined;
        const cancelsAtDate =
            cancelsAt !== undefined ? new Date(cancelsAt.year, cancelsAt.month - 1, cancelsAt.day) : undefined;

        const appTile =
            appID === undefined ? undefined : toTileDescription(appID, userID, tiles, loadTileDescriptionFromFirebase);

        const activeKebabMenu = () => {
            let items = [
                {
                    content: "Transfer subscription…",
                    onClick: (() => {
                        if (appTile !== undefined) {
                            this.showTransferAppModal(appTile)
                                .catch(async e => {
                                    logError("Could not show transfer modal", e);
                                    await this.props.modals.showSimpleInfoModal(
                                        "Error - Could not transfer subscription",
                                        DefaultErrorMessage
                                    );
                                })
                                .catch(logError);
                        }
                    }) as (() => void) | undefined,
                },
                {
                    content: "Cancel subscription…",
                    onClick: () => {
                        if (appTile !== undefined) {
                            this.showCancelAppModal(appTile, nextInvoiceDate)
                                .catch(async e => {
                                    logError("Could not show cancellation modal", e);
                                    await this.props.modals.showSimpleInfoModal(
                                        "Error - Could not cancel subscription",
                                        DefaultErrorMessage
                                    );
                                })
                                .catch(logError);
                        }
                    },
                    destroy: true,
                },
            ];

            if (nextInvoice !== undefined) {
                if (planSKU === SubscriptionSKU.ProAnnual && appID !== undefined) {
                    items = [
                        {
                            content: `Renews ${nextInvoice.month}/${nextInvoice.day}/${nextInvoice.year}`,
                            onClick: undefined,
                        },
                        { content: "Copy support link", onClick: () => this.makeSupportCode(appID) },
                        {
                            content: "Renew subscription today",
                            onClick: async () => {
                                const accept = await this.props.modals.showAcceptCancelModal(
                                    "Renew subscription",
                                    "Renew your subscription today?",
                                    "Renew"
                                );

                                if (accept) {
                                    const success = await legacyUpgrade({
                                        appID,
                                        action: "renew-now",
                                    });
                                    if (!success) {
                                        await this.props.modals.showSimpleInfoModal(
                                            "Something went wrong renewing your subscription",
                                            DefaultErrorMessage
                                        );
                                    }
                                    this.setState({ subscriptions: "loading" });
                                    await this.tryLoadSubscriptions();
                                }
                            },
                        },
                        ...items,
                    ];
                } else if (planSKU === SubscriptionSKU.ProMonthly && appID !== undefined) {
                    items = [
                        {
                            content: `Renews ${nextInvoice.month}/${nextInvoice.day}/${nextInvoice.year}`,
                            onClick: undefined,
                        },
                        {
                            content: "Upgrade to annual",
                            onClick: async () => {
                                const accept = await this.props.modals.showAcceptCancelModal(
                                    "Go annual",
                                    "Change to an annual subscription?",
                                    "Upgrade"
                                );

                                if (accept) {
                                    const success = await legacyUpgrade({
                                        appID,
                                        action: "go-annual",
                                    });
                                    if (!success) {
                                        await this.props.modals.showSimpleInfoModal(
                                            "Something went wrong upgrading your subscription",
                                            DefaultErrorMessage
                                        );
                                    } else {
                                        window.location.reload();
                                    }
                                    this.setState({ subscriptions: "loading" });
                                    await this.tryLoadSubscriptions();
                                }
                            },
                        },
                        ...items,
                    ];
                }
            }

            return {
                menuItems: items,
                menuDescriptionForItem: (i: typeof items[0]): ItemDescription => ({
                    name: i.content,
                    isEnabled: i.onClick !== undefined,
                    visualStyle: i.destroy ? "destructive" : "normal",
                }),
                menuOnItemClick: (i: typeof items[0]) => i.onClick?.(),
            };
        };

        const canceledKebabMenu = () => {
            if (appID === undefined) return null;

            const items = [
                {
                    content: "Restore subscription",
                    onClick: () => this.uncancelAppSubscription(appID),
                },
            ];

            return {
                menuItems: items,
                menuDescriptionForItem: (i: typeof items[0]): ItemDescription => ({
                    name: i.content,
                }),
                menuOnItemClick: (i: typeof items[0]) => i.onClick(),
            };
        };

        const isCustom = planSKU === "pro-custom";

        let menu: ReturnType<typeof activeKebabMenu> | null;
        if (cancelsAtDate === undefined) {
            menu = appTile !== undefined ? activeKebabMenu() : null;
        } else {
            menu = canceledKebabMenu() as any;
        }

        if (appTile?.iconImage === undefined) return null;

        const longName =
            "Legacy Pro, " + (planSKU === SubscriptionSKU.ProAnnual ? "Annual" : !isCustom ? "Monthly" : "Custom");

        const result = (
            <SubscriptionTile
                key={subscriptionID}
                title={appTile.title}
                icon={appTile.iconImage}
                iconBackground={appTile.primaryAccentColor}
                planShortName="Legacy Pro"
                planName={longName}
                actionTitle={"Edit Payment Info"}
                onChangePlan={() => this.onSubscriptionUpdateClick(checkoutSessionID)}
                {...menu}
            />
        );
        return result;
    };

    private renderUnifiedPlan = (
        plan: AppPlanCodeEntry,
        ownerID: string,
        _sub: MonthlySubscription | AnnualSubscription
    ) => {
        const { tiles, loadTileDescriptionFromFirebase, userData, history, unloadApps } = this.props;
        const { code, appIDs } = plan;

        const result = appIDs.map(appID => {
            const appTile =
                appID === undefined
                    ? undefined
                    : toTileDescription(appID, ownerID, tiles, loadTileDescriptionFromFirebase);

            if (appTile === undefined || appTile.iconImage === undefined) return null;

            const codeName = getPlanName(code);

            return (
                <SubscriptionTile
                    key={appID}
                    title={appTile.title}
                    icon={appTile.iconImage}
                    iconBackground={appTile.primaryAccentColor}
                    planName={codeName.long}
                    planShortName={codeName.short}
                    actionTitle={"Edit Plan"}
                    onChangePlan={() => openApp(appID, userData, history, unloadApps, appSettings(appID, "billing"))}
                />
            );
        });

        return result;
    };

    private renderUser(owner: Owner | undefined) {
        const { organizations, userData } = this.props;
        const { subscriptions } = this.state;

        let isAdmin = false;

        if (owner?.kind === OwnerKind.Organization && isUserData(userData)) {
            if (owner.memberUserIDs[0] === userData.id) {
                // FIXME: This isn't a good way to do this!
                isAdmin = true;
            }
        }

        let content: React.ReactNode;
        if (owner === undefined) {
            content = null;
        } else if (subscriptions === undefined) {
            if (owner.kind === OwnerKind.User) {
                content = this.renderError();
            } else {
                content = null;
            }
        } else if (subscriptions === "loading") {
            content = <LoadingIndicator />;
        } else if (isUserData(userData)) {
            // We want to render the current subscriptions first, and the soon-to-be-canceled subscriptions last.
            content = [
                ...subscriptions.filter(s => s.cancelsAt === undefined),
                ...subscriptions.filter(s => s.cancelsAt !== undefined),
            ].map(s => this.renderSubscription(userData.id, s));
        } else {
            content = null;
        }

        if (owner !== undefined) {
            const monthly = owner.monthlySubscription;
            const annual = owner.annualSubscription;
            if (monthly?.appPlanCodes !== undefined) {
                content = (
                    <>
                        {content}
                        {monthly.appPlanCodes.map(p => this.renderUnifiedPlan(p, owner.id, monthly))}
                    </>
                );
            }
            if (annual?.appPlanCodes !== undefined) {
                content = (
                    <>
                        {content}
                        {annual.appPlanCodes.map(p => this.renderUnifiedPlan(p, owner.id, annual))}
                    </>
                );
            }
        }

        return (
            <BillingScreenStyle>
                <div className="bill-nav">
                    <NavBreadcrumb items={makeNavBreadcrumbItems("Billing", this.orgID, organizations)} />
                    {isAdmin && (
                        <div className="bill-more">
                            <MoreMenu
                                items={["Delete team"]}
                                descriptionForItem={i => ({
                                    name: i,
                                    visualStyle: "destructive",
                                })}
                                onItemClick={this.deleteOrg}
                            />
                        </div>
                    )}
                </div>
                {this.renderBillingTransitionGroup(owner, content, true)}
            </BillingScreenStyle>
        );
    }

    public render() {
        const { match, organizations, userData } = this.props;
        const orgID = match.params.orgID;
        if (!isUserOrgID(orgID)) {
            const org = organizations.find(o => o.id === orgID);
            if (org !== undefined && getUserFeatures(org).unifiedPricing) {
                return this.renderUser(org);
            } else {
                return this.renderOrg(org);
            }
        } else {
            return this.renderUser(isUserData(userData) ? userData : undefined);
        }
    }
}

const mapState = (state: RootState) => ({
    organizations: state.organizations,
    userData: state.userData,
    tiles: state.tiles,
});

const mapDispatch = {
    loadTileDescriptionFromFirebase: actions.loadTileDescriptionFromFirebase,
    unloadApps: appsActions.unloadApps,
};

const BillingScreen = withModalProvider(connect(mapState, mapDispatch)(BillingScreenImpl));
export default withTheme(BillingScreen);
